import React, { useState, useEffect } from 'react';
import { FIELD_ID } from './invoice.const';
import {
  DECIMAL_NEGATIVE_PATTERN,
  DECIMAL_PATTERN,
  DECIMAL_PATTERN_EXTENDED,
  DECIMAL_PATTERN_EXTENDED_MAX
} from '../utils/validation';

let timer;

export const RowResource = ({
  typeName,
  name,
  counterName,
  view,
  qty,
  progress,
  id,
  resourceId,
  qtyInputName,
  rate,
  rateInputName,
  discount,
  discountInputName,
  subtotal,
  salesTax,
  salesTaxInputName,
  totalSalesTax,
  taxable,
  taxableTaxInputName,
  total,
  onDelete,
  onBlur,
  onTableChange
}) => {
  let amount = qty * rate;
  if (typeof amount !== 'number') {
    amount = 0;
  }

  const [discountNumber, setDiscountNumber] = useState(0);
  const [localDiscount, setDiscount] = useState(0);
  const [updateDiscount, setUpdateDiscount] = useState(true);

  const onTableChangeDiscount = e => {
    clearTimeout(timer);
    setUpdateDiscount(false);
    const id = e.currentTarget.id;
    const evenTargetName = e.currentTarget.name;
    const value = e.currentTarget.value * 100;
    let discountPercent;

    if (amount && !isNaN(value)) {
      discountPercent = (value / amount).toFixed(2);
    } else {
      discountPercent = 0;
    }

    setDiscountNumber(e.currentTarget.value);
    onTableChange({
      currentTarget: {
        id,
        name: evenTargetName,
        value: discountPercent
      }
    });

    timer = setTimeout(() => {
      setUpdateDiscount(true);
    }, 3000);
  };

  useEffect(() => {
    if (localDiscount !== discount) {
      const newDiscountNumber = ((discount * amount) / 100).toFixed(2);

      if (!isNaN(newDiscountNumber) && updateDiscount) {
        setDiscountNumber(newDiscountNumber);
      }

      setDiscount(discount);
    }
  });

  return (
    <tr>
      {/*Resources*/}
      <td className="text-left col-md-4">
        <b>{typeName}</b> {name}
        {counterName ? <b>{`: ${counterName}`}</b> : null}
      </td>
      {/*QTY*/}
      <td className="text-right col-md-2">
        {view ? (
          <span>{qty}</span>
        ) : (
          <input
            id={FIELD_ID.QTY}
            type="text"
            pattern={DECIMAL_PATTERN_EXTENDED_MAX}
            className="form-control table-input pull-right"
            name={qtyInputName}
            value={qty}
            disabled={progress}
            onChange={onTableChange}
            onBlur={onBlur}
            required
          />
        )}
      </td>
      {/*Rate*/}
      <td className="text-right col-md-2">
        {view ? (
          <span>{rate}</span>
        ) : (
          <input
            id={FIELD_ID.RATE}
            type="text"
            pattern={DECIMAL_PATTERN_EXTENDED_MAX}
            className="form-control table-input pull-right"
            name={rateInputName}
            value={rate}
            disabled={progress}
            onChange={onTableChange}
            onBlur={onBlur}
            required
          />
        )}
      </td>
      {/*Amount*/}
      <td className="text-right col-md-1">
        <span>{amount.toFixed(2)}</span>
      </td>
      {/*Discount, %*/}
      <td className="text-right col-md-1">
        {view ? (
          <span>{discount}</span>
        ) : (
          <input
            type="text"
            id={FIELD_ID.DISCOUNT_PERCENTAGE}
            pattern={DECIMAL_PATTERN_EXTENDED_MAX}
            className="form-control table-input pull-right"
            name={discountInputName}
            value={discount}
            disabled={progress}
            onChange={onTableChange}
            onBlur={onBlur}
            required
          />
        )}
      </td>
      {/*Discount*/}
      <td className="text-right col-md-1">
        {view ? (
          <span>{discountNumber}</span>
        ) : (
          <input
            type="text"
            id={FIELD_ID.DISCOUNT}
            pattern={DECIMAL_PATTERN_EXTENDED_MAX}
            className="form-control table-input pull-right"
            name={discountInputName}
            value={discountNumber}
            disabled={progress}
            onBlur={onBlur}
            onChange={onTableChangeDiscount}
            required
          />
        )}
      </td>

      {/*Subtotal*/}
      <td className="text-right col-md-1">
        <span>{subtotal}</span>
      </td>
      {/*Taxable*/}
      <td className="text-right col-md-1">
        {view ? (
          <span>{Boolean(taxable) ? 'yes' : 'no'}</span>
        ) : (
          <input
            id={FIELD_ID.TAXABLE}
            style={{ height: '16px' }}
            type="checkbox"
            className="form-control table-input pull-right"
            name={taxableTaxInputName}
            value={taxable}
            checked={taxable}
            disabled={progress}
            onChange={onTableChange}
            onBlur={onBlur}
            required
          />
        )}
      </td>
      {/*Tax Rate, %*/}
      <td className="text-right col-md-1">
        {view ? (
          <span>{salesTax}</span>
        ) : (
          <div className="parent-tax-input">
            <input
              type="text"
              id={FIELD_ID.SALES_TAX}
              pattern={DECIMAL_PATTERN_EXTENDED_MAX}
              className="form-control table-input pull-right"
              name={salesTaxInputName}
              value={salesTax}
              disabled={progress}
              onChange={onTableChange}
              onBlur={onBlur}
              required
            />
          </div>
        )}
      </td>
      {/*Tax*/}
      <td className="text-right col-md-1">
        <span>{totalSalesTax || '0.00'}</span>
      </td>
      <td className="text-right col-md-1">${total ? parseFloat(total).toFixed(2) : '0.00'}</td>
      {view ? null : (
        <td className="text-right col-md-1">
          <button
            type="button"
            data-id={id}
            data-resourceid={resourceId}
            disabled={progress}
            className="delete-product-btn"
            onClick={onDelete}
          >
            Delete
          </button>
        </td>
      )}
    </tr>
  );
};
